"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "WHAT IS NEURO-SENSORY TRAINING?",
  answer: "It is a data-driven approach that targets the nervous system to improve how your brain processes movement. By refining these neural pathways, we can significantly reduce chronic pain and unlock higher levels of athletic performance."
}, {
  question: "HOW SOON WILL I SEE PERFORMANCE GAINS?",
  answer: "Many athletes notice immediate changes in range of motion and stability during their first session. Long-term neural adaptations and significant pain reduction typically occur within 4 to 6 weeks of consistent training."
}, {
  question: "DO I NEED A DOCTOR'S REFERRAL?",
  answer: "No referral is necessary. We begin with a comprehensive movement assessment to identify your specific neural and mechanical gaps, allowing us to build a custom performance plan immediately."
}, {
  question: "IS THIS ONLY FOR PROFESSIONAL ATHLETES?",
  answer: "While we work with elite competitors, our methods are designed for any active adult looking to move without pain. If you value high-performance living and precision care, this is for you."
}, {
  question: "WHAT HAPPENS DURING THE INITIAL ASSESSMENT?",
  answer: "We conduct a deep-dive into your movement patterns, visual system, and vestibular balance. This 'Neuro-Map' identifies exactly where your system is compensating, which is often the root cause of your pain."
}, {
  question: "HOW ARE SESSIONS STRUCTURED?",
  answer: "Every session is one-on-one. We combine manual therapy with targeted neuro-drills and strength work, ensuring every minute is focused on your specific athletic goals and recovery needs."
}];
export default function MovementMasteryFaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261974" id="movement-mastery-faq" className="bg-background text-foreground py-24">
      <div ref={ref} className={`page-container max-w-3xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-default mb-4 uppercase tracking-wider text-foreground">
            MOVEMENT{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/80">
              MASTERY FAQ
            </span>
          </h2>
          <p className="text-muted-foreground text-lg font-default uppercase italic">
            Precision answers for high-performance recovery.
          </p>
        </div>

        <Accordion type="single" collapsible className="w-full space-y-4">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-b border-primary/10 bg-transparent rounded-md overflow-hidden">
              <AccordionTrigger className="px-6 py-5 text-foreground hover:no-underline font-bold font-default text-left text-base uppercase tracking-wide [&_svg]:text-primary">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="px-6 pb-5 text-muted-foreground text-base leading-relaxed font-default">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}